// extracted by mini-css-extract-plugin
export var fullWidthImage = "fullWidthImage-module--full-width-image--OCvj0";